import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { typographies } from "../../styles/figmaTypographies";
import styled, { css } from "styled-components";
import { Spacer } from "./Spacer";
import { TextCapitalized } from "./text/TextCapitalized";
import { colors } from "../../styles/figmaColors";
import { Tag } from "./Tag/Tag";

type DirectionType = "top" | "right" | "bottom" | "left";

interface TooltipHoverProps {
  id: string;
  place: DirectionType;
  title?: string;
  content?: string;
  isOpen?: boolean;
  badge?: string;
  onDismiss?: () => void;
}

export const TooltipHover = (props: TooltipHoverProps) => {
  const { t } = useTranslation();
  const typoTitle = typographies["Header/H6"];
  const typoContent = typographies["Body/XXS"];

  return (
    <>
      <StyledContainer
        id={props.id}
        place={props.place}
        isOpen={props.isOpen}
        clickable={!!props.onDismiss}
      >
        <Spacer x={1} />
        <StyledColumn>
          <Spacer y={0.75} />
          {props.badge && (
            <>
              <Tag
                text={props.badge}
                backgroundColor={colors["colors/accent/500"]}
                textColor={colors["colors/accent/900"]}
              />
              <Spacer y={0.5} />
            </>
          )}
          <TextCapitalized>
            <StyledTooltipContent typo={typoTitle}>
              {props.title}
            </StyledTooltipContent>
          </TextCapitalized>
          {props.title && <Spacer y={0.5} />}
          <TextCapitalized>
            <StyledTooltipContent typo={typoContent}>
              {props.content}
            </StyledTooltipContent>
          </TextCapitalized>
          {props.onDismiss && (
            <>
              <Spacer y={0.75} />
              <StyledButtonDiv onClick={props.onDismiss}>
                <TextCapitalized>{t("tooltipHover.dismiss")}</TextCapitalized>
              </StyledButtonDiv>
            </>
          )}
          <Spacer y={0.75} />
        </StyledColumn>
        <Spacer x={1} />
      </StyledContainer>
    </>
  );
};
interface StyledContentArgs {
  typo: string;
}

const StyledContainer = styled(Tooltip)`
  display: flex;
  flex-direction: row;
  border-radius: 0.5rem !important;
  background-color: ${colors["colors/button/primary/default"]} !important;
  max-width: 17rem;
  z-index: 666;
  padding: 0 !important;
  margin: 0 !important;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTooltipContent = styled.div<StyledContentArgs>`
  ${({ typo }) => css`
    ${typo}
  `};
  color: ${colors["colors/text/white"]} !important;
`;

const StyledButtonDiv = styled.div`
  ${typographies["Header/H6"]}
  align-self: flex-end;
  cursor: pointer;
  color: ${colors["colors/accent/500"]};
`;
